// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fBNhq","title":"styles_title__uu7Vr","buttonWrapper":"styles_buttonWrapper__Cc1BA"};